export default "__VITE_ASSET__4f601d66__"